'use client';

import * as DS from '@aurorasolar/ds';

type Cell = { label: string; value: string };

type Props = {
  cells: Cell[];
};

// The results readout: a bordered strip of label-over-figure cells, stacked on
// mobile and side by side on desktop. Shared by the bill totals and the
// state-average comparison so both tiers read as the same instrument.
export const ReadoutStrip = ({ cells }: Props) => (
  <DS.Flex
    borderColor="uiDivider"
    borderRadius={16}
    borderStyle="solid"
    borderWidth="1px"
    flexDirection={{ _: 'column', md: 'row' }}
  >
    {cells.map(({ label, value }, i) => (
      <DS.Flex
        borderColor="uiDivider"
        borderLeftWidth={{ _: 0, md: i > 0 ? '1px' : 0 }}
        borderStyle="solid"
        borderTopWidth={{ _: i > 0 ? '1px' : 0, md: 0 }}
        // Mobile: lock every stacked cell to exactly 85px. flex-basis 85 sets the height, and
        // minH=0 overrides the flex default (min-height:auto), which was letting a cell's
        // min-content push it taller than 85 (border-box, so the divider border is absorbed).
        // Desktop: flex:1 equal-width columns.
        flex={{ _: '0 0 85px', md: 1 }}
        gap={2}
        justifyContent={{ _: 'center', md: 'flex-start' }}
        key={label}
        minH={{ _: 0, md: 'auto' }}
        // No vertical padding on mobile — the fixed height + centering handles the spacing
        px={6}
        py={{ _: 0, md: 6 }}
        textAlign="left"
      >
        {/* nowrap keeps the label and value on one line each so the fixed-height cell never clips */}
        <DS.Text color="uiHelperCopy" text="body14" whiteSpace="nowrap">
          {label}
        </DS.Text>
        <DS.Text text={{ _: 'h3', md: 'h2' }} whiteSpace="nowrap">
          {value}
        </DS.Text>
      </DS.Flex>
    ))}
  </DS.Flex>
);
